import {
  RatioColumn,
  RatioSourceRef,
  morningstarDataPaths,
  surveyDataPaths
} from '../parameters-schema';

export const formatRatioPercent = (value: number): string => {
  const percentValue = Math.round(value * 10000) / 100;
  return `${percentValue}%`;
};

export const formatRatioPercentInput = (value: number): string => {
  const percentValue = Math.round(value * 10000) / 100;
  return percentValue.toString();
};

export const getRatioSourceLabel = (ref: RatioSourceRef): string => {
  if (ref.source === 'morningstarData') {
    return morningstarDataPaths[ref.path] || ref.path;
  }
  return surveyDataPaths[ref.path] || ref.path;
};

export const formatRatioDescription = (column: RatioColumn): string => {
  if (column.displayName?.trim()) {
    return column.displayName;
  }

  const numeratorLabel = column.numerator.map(getRatioSourceLabel).join(' + ');
  const denominatorLabel = column.denominator.map(getRatioSourceLabel).join(' + ');
  return `${numeratorLabel} / ${denominatorLabel}`;
};
